import React from 'react'

interface TelephoneIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const TelephoneIcon: React.FC<TelephoneIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Telephone icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='6 3 12 18'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M10.717 4.445a18.24 18.24 0 00-.48-.819c-.245-.412-.588-.686-1-.796-.408-.11-.846-.045-1.277.19l-1.523.875c-.554.318-.943.78-1.159 1.378-.266.75-.342 1.6-.24 2.682.156 1.672.626 3.312 1.482 5.158a17.03 17.03 0 004.33 5.738c.699.593 1.649 1.328 2.82 1.724l.01.003c.07.022.137.043.208.062.8.215 1.517.112 2.193-.315.004-.002.012-.007.017-.012.23-.163.476-.3.735-.443l.057-.032c.19-.103.384-.212.573-.326.875-.528 1.117-1.431.61-2.305l-1.415-2.442c-.237-.427-.581-.712-.993-.822-.411-.11-.855-.037-1.282.209l-1.458.838c-.09-.09-.185-.173-.274-.252a4.108 4.108 0 01-.302-.287c-.87-.943-1.59-2.063-2.202-3.418-.305-.703-.483-1.272-.565-1.826.375-.192.734-.4 1.082-.606.123-.074.25-.146.376-.219.44-.253.733-.603.842-1.01.11-.406.033-.856-.225-1.295l-.702-1.212c-.08-.138-.155-.272-.232-.409l-.006-.011zM9.898 7.31c.133-.08.267-.156.39-.226l.004-.003a.575.575 0 00.135-.1.542.542 0 00-.064-.147l-.003-.006-.702-1.211c-.086-.148-.166-.29-.242-.425l-.008-.015a16.837 16.837 0 00-.44-.75l-.01-.019-.012-.018a.378.378 0 00-.081-.103c-.01-.008-.013-.009-.016-.01h-.004l-.018.001a.459.459 0 00-.14.052l-1.503.864c-.248.143-.4.325-.493.584-.171.481-.248 1.098-.16 2.034l.001.004c.136 1.469.55 2.942 1.348 4.663a15.53 15.53 0 003.944 5.231c.665.563 1.43 1.137 2.314 1.439.069.022.104.032.138.041.399.107.677.063.972-.114.295-.208.605-.379.848-.513l.066-.037.009-.005c.18-.099.354-.196.517-.295a.525.525 0 00.147-.122v-.004a.436.436 0 00-.059-.141l-1.423-2.455-.007-.013a.387.387 0 00-.072-.098h-.002a.447.447 0 00-.142.058l-2.45 1.41-.813-.808a5.003 5.003 0 00-.21-.192 5.525 5.525 0 01-.411-.394M9.898 7.31c-.345.204-.668.392-.997.56l-.961.49.158 1.066c.108.725.336 1.425.672 2.202l.005.01.005.011c.667 1.477 1.47 2.738 2.466 3.818'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default TelephoneIcon
